// @ts-nocheck
/* eslint-disable */
export const homeIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99992 4.12683L11.3333 7.12683V12.3335H9.99992V8.3335H5.99992V12.3335H4.66659V7.12683L7.99992 4.12683ZM7.99992 2.3335L1.33325 8.3335H3.33325V13.6668H7.33325V9.66683H8.66659V13.6668H12.6666V8.3335H14.6666L7.99992 2.3335Z" fill="currentColor"/></svg>`,
    name: 'home' as const
};